import styled from 'styled-components'
import { Pagination as BasePagination, PaginationItem as BasePaginationItem } from '@material-ui/lab'

export const RootPagination = styled(BasePagination)`
  margin: ${({ alignment }) => {
    switch (alignment) {
      case 'right':
        return '0 0 0 auto'
      case 'center':
        return '0 auto'
      case 'left':
        return '0 auto 0 0'
      default:
        return '0 auto 0 0'
    }
  }};
  width: fit-content;

  & .MuiPagination-ul {
    margin: 0 0 0 auto;

    li {
      margin: 0 2px 0 0;
    }

    li:last-child {
      margin-right: 0;
    }
  }

  & .MuiPaginationItem-ellipsis {
    color: ${props => props.theme.palette.gray[35]};
  }
`

export const PaginationItem = styled(BasePaginationItem)`
  &.MuiPaginationItem-root {
    background-color: ${props => props.theme.palette.brand.white};
    border: none;
    border-radius: 4px;
    color: ${props => props.theme.palette.gray[35]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    height: 40px;
    line-height: 18px;
    margin: 3px;
    min-width: 40px;
    padding: 0;
    width: 40px;

    &.Mui-selected {
      background-color: ${props => props.theme.palette.blue[50]};
      color: ${props => props.theme.palette.brand.white};
    }

    &.MuiPaginationItem-sizeSmall {
      font-size: 12px;
      height: 30px;
      min-width: 30px;
      padding: 0;
      width: 30px;
    }

    &.MuiPaginationItem-sizeLarge {
      font-size: 18px;
      height: 50px;
      min-width: 50px;
      padding: 0;
      width: 50px;
    }

    &.MuiPaginationItem-outlinedPrimary.Mui-selected {
      background-color: ${props => props.theme.palette.brand.white};
      color: ${props => props.theme.palette.blue[50]};
      border: 1px solid ${props => props.theme.palette.blue[50]};
    }
  }

  &.MuiPaginationItem-page.Mui-selected:hover,
  &.MuiPaginationItem-page.Mui-selected.Mui-focusVisible {
    background-color: ${props => props.theme.palette.blue[50]};
    cursor: default;
  }

  &.MuiPaginationItem-outlinedPrimary.Mui-selected:hover,
  &.MuiPaginationItem-outlinedPrimary.Mui-selected.Mui-focusVisible {
    background-color: ${props => props.theme.palette.brand.white};
    color: ${props => props.theme.palette.blue[50]};
    border: 1px solid ${props => props.theme.palette.blue[50]};
  }

  &.MuiPaginationItem-page:hover {
    background-color: ${props => props.theme.palette.blue[95]};
  }

  & .MuiPaginationItem-icon {
    font-size: 1.375rem;
  }

  &.MuiPaginationItem-page.Mui-disabled {
    color: ${props => props.theme.palette.gray[75]};
    opacity: 1;
  }
`

export const PaginationWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: ${props => (props.alignment === 'center' ? 'column' : 'row')};
  justify-content: space-between;
  width: 100%;
`

export const Strong = styled.span`
  font-weight: bold;
`
